"use strict";
/**
 * Copyright © 2020 Johnson & Johnson
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});

var core_1 = require("@bodiless/core");

var lodash_1 = require("lodash");

var TagButton_1 = require("../TagButton");

var emptyValue = {
  tags: []
}; // Composed hoc which creates editable version of the component.
// Note - the order is important. In particular:
// - the node data handlers must be outermost
// - anything relying on the context (activator, indicator) must be
//   *after* `withEditButton()` as this establishes the context.
// - withData must be *after* the data handlers are defiend.

var asTaggableItem = function asTaggableItem(nodeKey) {
  return lodash_1.flowRight(core_1.withNodeKey(nodeKey), core_1.withNode, core_1.withNodeDataHandlers(emptyValue), core_1.ifEditable(TagButton_1.withTagButton, core_1.withContextActivator('onClick'), core_1.withLocalContextMenu), core_1.withoutProps(['registerSuggestions', 'getSuggestions', 'allowNew', 'noSuggestionsText', 'componentData', 'inputAttributes', 'seeAllText', 'formBodyText', 'formTitle', 'setComponentData']));
};

exports.default = asTaggableItem;